import {Component, EventEmitter, Output} from '@angular/core';

@Component({
  selector: 'app-wide-header',
  imports: [],
  templateUrl: './wide-header.component.html',
  styleUrl: './wide-header.component.scss'
})
export class WideHeaderComponent {
@Output() click = new EventEmitter();

  onClick($event: Event) {
    this.click.emit($event);
  }
}
